(function () {
  'use strict';

  angular
    .module('directive.cookies-info', [])

    .directive('cookiesInfo', function () {
      return {
        restrict: 'A',
        controllerAs: 'cookiesCtrl',
        /* @ngInject */
        controller: ["$scope", "$cookies", "$timeout", "DateService", function ($scope, $cookies, $timeout, DateService) {
          if ($cookies.get('cookiesOK')) return;

          var ctrl = this;

          $timeout(function () {
            if (!$cookies.get('firstPage')) {
              setFirstPage();
              ctrl.active = true;
            } else {
              setCookiesOK();
            }
          });

          ctrl.clickCookiesOK = function () {
            ctrl.active = false;
            setCookiesOK();
          };

          // Events

          var unwatch = $scope.$on('$locationChangeStart', function () {
            ctrl.active = false;
          });
          $scope.$on('$destroy', unwatch);

          // Functions

          function setFirstPage() {
            $cookies.put('firstPage', 'true', {
              path: '/',
              expires: DateService.tomorrow()
            });
          }
          function setCookiesOK() {
            $cookies.put('cookiesOK', 'true', {
              path: '/',
              expires: DateService.nextYear()
            });
          }

        }]
      };

    });

})();
